import type { BidType } from '@/features/bidding/constants'
import { ManualAcceptFlow, MarketProgram, Status } from '@/features/bidding/constants'
import type { ExtendedBid } from '@/features/bidding/types/bid'
import { MarketDate } from '@/features/bidding/utils/date/marketDate'
import { getStateOfMarket } from '@/features/bidding/utils/getStateOfMarket'

export const isManuallyAcceptable = (status: Status): boolean => {
  return status == Status.OFFERED
}

export const isManuallyEditable = (status: Status): boolean => {
  return [Status.MANUALLY_EDITED, Status.MANUALLY_ACCEPTED, Status.ACCEPTED, Status.PARTIALLY_ACCEPTED].includes(status)
}

type IsBidEditableParams = {
  deliveryDay: MarketDate
  marketProgram: MarketProgram
  bidType: BidType
  selectedCountry: CountryIdentifier
}
export const isBidEditable = ({ deliveryDay, marketProgram, bidType, selectedCountry }: IsBidEditableParams) => {
  // Do not allow editing of bids that are already in the past
  if (deliveryDay < new MarketDate()) {
    return false
  }

  if (selectedCountry === 'gr') {
    return false
  }

  // aFRR can only be bid with the auto-trader for now, but we want users to see the results
  const nonEditableMarketPrograms = [MarketProgram.AFRR_DOWN, MarketProgram.AFRR_UP]
  if (nonEditableMarketPrograms.includes(marketProgram)) {
    return false
  }

  const stateOfMarket = getStateOfMarket(deliveryDay, marketProgram, bidType)

  // We allow editing only if the market is not closed
  return stateOfMarket !== 'CLOSED'
}

export const updateBidStatus = (bid: ExtendedBid, manualAcceptFlow: ManualAcceptFlow): ExtendedBid => {
  switch (manualAcceptFlow) {
    case ManualAcceptFlow.CREATE:
      return {
        ...bid,
        status: Status.MANUALLY_ACCEPTED,
      }
    case ManualAcceptFlow.EDIT:
      return {
        ...bid,
        status: Status.MANUALLY_EDITED,
      }
    default:
      throw new Error(`Invalid edit flow: ${manualAcceptFlow}`)
  }
}
